export default {
      id: "icon--schools-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--schools-usage",
      toString: function () {
        return this.url;
      }
    }